<template>
  <UiModal
    ref="vendorDetailsPopup"
    :class="$style['custom-modal']"
    @close="close"
  >
    <div :class="$style.title">
      {{
        selectedVendor.id
          ? $t('vendorsPage.vendorModal.edit', { vendor: selectedVendor.label })
          : $t('vendorsPage.vendorModal.add')
      }}
    </div>
    <div :class="$style.subtitle">
      {{ $t('vendorsPage.vendorModal.note') }}
    </div>
    <UiSteps :total="5" :active="step" :class="$style.steps" />
    <UiContainer :class="$style.container" size="large">
      <MCAVendorInfo v-if="step === 0" @next-tab="next" />
      <MCAVendorCurrency v-if="step === 1" @next-tab="next" @prev-tab="prev" />
      <MCAVendorAddress
        v-if="step === 2"
        :required-vendor-fields-with-validation="
          requiredVendorFieldsWithValidation
        "
        @next-tab="next"
        @prev-tab="prev"
      />
      <MCAVendorBank
        v-if="step === 3"
        :required-vendor-fields-with-validation="
          requiredVendorFieldsWithValidation
        "
        @next-tab="next"
        @prev-tab="prev"
      />
      <MCAVendorSummary v-if="step === 4" @prev-tab="prev" @next-tab="next" />
      <MCAVendorInvoice v-if="step === 5" @next-tab="next" />
    </UiContainer>
  </UiModal>
</template>

<script>
import { mapGetters } from 'vuex';
import { UiModal, UiSteps, UiContainer } from 'ui-components';
import MCAVendorInfo from './MCAVendorInfo.vue';
import MCAVendorBank from './MCAVendorBank.vue';
import MCAVendorCurrency from './MCAVendorCurrency.vue';
import MCAVendorAddress from './MCAVendorAddress.vue';
import MCAVendorSummary from './MCAVendorSummary.vue';
import MCAVendorInvoice from './MCAVendorInvoice.vue';
export default {
  components: {
    UiModal,
    UiSteps,
    UiContainer,
    MCAVendorInfo,
    MCAVendorBank,
    MCAVendorCurrency,
    MCAVendorAddress,
    MCAVendorSummary,
    MCAVendorInvoice,
  },
  data() {
    return {
      step: 0,
    };
  },
  computed: {
    ...mapGetters(['selectedVendor', 'requiredVendorFieldsWithValidation']),
  },
  methods: {
    /** @public */
    open(step) {
      if (step) this.step = step;
      this.$refs.vendorDetailsPopup.open();
    },
    close() {
      this.step = 0;
      this.$store.dispatch('CLEAR_SELECTED_VENDOR');
      this.$emit('done');
    },
    async next(nextNode) {
      if (nextNode) {
        const { details, beneficiaryAddress, bankAddress, ...rest } = nextNode;
        const updatedVendor = {
          ...this.selectedVendor,
          details: {
            ...this.selectedVendor.details,
            ...details,
          },
          beneficiaryAddress: {
            ...this.selectedVendor.beneficiaryAddress,
            ...beneficiaryAddress,
          },
          bankAddress: {
            ...this.selectedVendor.bankAddress,
            ...bankAddress,
          },
          ...rest,
        };
        await this.$store.dispatch('UPDATE_SELECTED_VENDOR', updatedVendor);
      }
      if (this.step === 5) {
        this.$refs.vendorDetailsPopup.close();
        this.close();
        return;
      }
      this.step++;
    },
    prev() {
      if (this.step) this.step--;
    },
  },
};
</script>
<style lang="less" module>
.container {
  padding: 0;
}
.steps {
  bottom: auto;
}
.title {
  color: currentColor;
  font-size: 45px;
  line-height: 45px;
  text-align: left;
  padding-bottom: 10px;
}
.subtitle {
  color: gray;
  font-size: 12px;
  text-align: left;
}
.custom-modal {
  div[class^='modal_'] {
    min-height: 400px;
    max-height: 80%;
    height: auto;
    min-width: 300px;
    max-width: 750px;
    width: 80%;
    overflow: auto;
    div[class^='content_'] {
      margin: 0;
      max-width: 100%;
      div[class^='container_'] {
        min-height: 250px;
        height: fit-content;
        max-height: 100%;
        margin-bottom: 100px;
      }
    }
  }
}
</style>
